import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { CardMetadata } from '@/components/block/common/card-metadata'
import { Page } from '@/components/layout/page'
import { CardExtendTable } from '@/components/ui/card-extend'
import { Table } from '@/components/ui/table'

import { outletMasterApi } from '@/features/outlet/outlet-api'

import { useAuth } from '@/lib/auth'
import { dateId } from '@/libs/utils/format'

export const Route = createFileRoute('/_app/profile/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <Page.TwoColumn>
        <Page.Column>
          <SectionProfile />
        </Page.Column>
        <Page.Column>
          <OutletAccess />
        </Page.Column>
      </Page.TwoColumn>
    </Page>
  )
}

function SectionProfile() {
  const { account } = useAuth()

  return (
    <CardMetadata
      title='Informasi Akun'
      contents={{
        ID: account.id,
        Name: account.name,
        Email: account.email,
        Status: account.status,
        'Created At': dateId(account.createdAt),
        'Updated At': dateId(account.updatedAt!),
      }}
    />
  )
}

function OutletAccess() {
  const { data } = useSuspenseQuery(
    outletMasterApi.list.query({
      params: {},
    })
  )

  return (
    <CardExtendTable title='Akses Outlet'>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.Head>Outlet</Table.Head>
            <Table.Head>Role</Table.Head>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data?.data.outlets.map(outlet => (
            <Table.Row key={outlet.id}>
              <Table.Cell>{outlet.name}</Table.Cell>
              <Table.Cell>Admin</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </CardExtendTable>
  )
}
